import React, { Fragment, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Container from '../../components/Container';

import store from '../../photos/store.jpg';

const AboutWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
    ${props => props.theme.breakpoints.down('md')} {
        flex-direction: column;
    }
`;

const StoreImage = styled.div`
    align-self: center;
    flex: 1 1 50%;
    ${props => props.theme.breakpoints.down('md')} {
        margin-bottom: 16px;
    }
`;

const Image = styled.img`
    ${props => props.theme.breakpoints.down('xs')} {
        width: 100%;
    }
    ${props => props.theme.breakpoints.up('sm')} {
        width: 80%;
    }
`;

const AboutKomugiya = styled.div`
    flex: 1 1 50%;
    margin-bottom: 24px;
`;

const About = () => {

    useEffect(() => window.scrollTo(0,0));

    return (
        <Fragment>
            <Header />
                <Container>
                    <Typography variant="h6">小麦屋について</Typography>
                    <AboutWrapper>
                        <StoreImage>
                            <Image src={store} />
                        </StoreImage>
                        <AboutKomugiya>
                            <Typography variant="body1">
                                車庫の奥にある小さな部屋から小麦屋は始まりました。<br />
                                <br />
                                子育てをしながら趣味で始まったパン作り。<br />
                                <br />
                                お一人でも多くの方にパンをご提供したいと思い、<br />
                                お一人お一人のご自宅に移動販売が始まりました。<br />
                                <br />
                                その後、<br />
                                近所の皆さんにも優しいパンを食べてもらいたいと思い <br />
                                2002年 焼津市浜当目に小麦屋を開店 <br />
                                2021年 焼津市石脇上にお店を移転 <br />
                                しました。<br />
                                <br />
                                小麦屋が提供するパンは、毎日食べることができる、家庭にいつもある素朴なパン、<br />
                                お子様でも安心してお召しになれるような優しいパン、<br />
                                調理パンにのっているお野菜は、近くの農家さんで採れたものを使用することも多いご近所さんのパンです。<br />
                                <br />
                                お子様が一人で来れるような <br />
                                上京して懐かしく思ってもらえるような <br />
                                パン屋になるよう今後も心を込めてパンをおつくりします <br />
                            </Typography>
                        </AboutKomugiya>
                    </AboutWrapper>
                </Container>
            <Footer />
        </Fragment>
    )
}

export default About;